import React from 'react';
import { Box, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// Import your icons
import appleIcon from '/src/assets/images/stopper/appleI.png?url';
import plusIcon from '/src/assets/images/stopper/identify.png?url';
import completeIcon from '/src/assets/images/stopper/document.png?url';
import smsIcon from '/src/assets/images/stopper/smartphone.png?url';
import appIcon from '/src/assets/images/stopper/form.png?url';
interface StepInfo {
  label: string;
  imgSrc: string;
}

interface StopperProps {
  /**
   * Index into `steps` below. ثبت موبایل (index 0) happens during signup, so
   * the wizard's own first screen — ایجاد هویت — is index 1, which is why
   * `currentStep` is passed through unchanged.
   */
  activeStep: number;
}

// Shared by several flows (Wizard.tsx, Identify.tsx, Intro.tsx), so the list
// covers the full publisher journey, not just the app-submission subset any
// one page happens to render.
const steps: StepInfo[] = [
  { label: 'ثبت موبایل', imgSrc: appleIcon },
  { label: 'ایجاد هویت', imgSrc: plusIcon },
  { label: 'ثبت اپلیکیشن', imgSrc: appIcon },
  { label: 'اطلاعات اپ', imgSrc: plusIcon },
  { label: 'ارسال SMS', imgSrc: smsIcon },
  { label: 'تکمیل اطلاعات', imgSrc: completeIcon },
];

const StopperDeveloper: React.FC<StopperProps> = ({ activeStep }) => {
  return (
    <Box
      sx={{
        width: '520px',
        // Without this the padding and border sat outside the 520px, making
        // this card 527px and wider than the form card below it.
        boxSizing: 'border-box',
        direction: 'rtl',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 136,
        height: 136,
        backgroundColor: '#FFFFFF',
        borderRadius: '12px',
        padding: 2.5,
        marginTop: '32px',
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        '@media (max-width: 768px)': {
          width: '100%',
          maxWidth: '350px',
          padding: 1.5,
        },
      }}
    >
      <Typography
        component="div"
        variant="h6"
        gutterBottom
        align="center"
        sx={{
          fontFamily: 'IRANYekanXFaNum',
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: '16px',
          textAlign: 'center',
          color: '#374151',
          marginBottom: 2,
        }}
      >
        مراحل ثبت اپلیکیشن در سیبچه
      </Typography>

      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        alignItems="flex-start"
      >
        {steps.map((step, index) => (
          <Box
            key={index}
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{
              flex: 1,
              position: 'relative',
              '&:not(:last-child)::after': {
                content: '""',
                position: 'absolute',
                top: '22px',
                left: '-50%',
                width: '100%',
                height: '2px',
                background: index < activeStep ? '#10B981' : '#E5E7EB',
                zIndex: 1,
                transition: 'background 0.3s ease',
              },
            }}
          >
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                zIndex: 2,
                transition: 'all 0.3s ease',
                backgroundColor:
                  index < activeStep
                    ? '#16A34A' // سبز مرحله انجام‌شده
                    : index === activeStep
                      ? '#789ff4' // آبی مرحله فعال
                      : '#E5E7EB', // خاکستری مرحله آینده
                border:
                  index === activeStep
                    ? '2px solid #2563EB'
                    : '2px solid transparent',
                boxShadow:
                  index === activeStep
                    ? '0 0 0 4px rgba(37, 99, 235, 0.1)'
                    : 'none',
              }}
            >
              <img
                src={step.imgSrc}
                alt={step.label}
                style={{
                  width: 20,
                  height: 20,
                  filter:
                    index === activeStep || index < activeStep
                      ? 'brightness(0) invert(1)'
                      : 'opacity(0.5)',
                  transition: 'filter 0.3s ease',
                }}
              />
            </Box>

            <Typography
              sx={{
                fontFamily: 'IRANYekanXFaNum',
                fontWeight: index === activeStep ? 600 : 500,
                fontSize: '10px',
                lineHeight: '14px',
                textAlign: 'center',
                color: index === activeStep ? '#1F2937' : '#9CA3AF',
                marginTop: '8px',
                transition: 'color 0.3s ease',
                // Wide enough for "ارسال جهت بررسی" on one line at 520px.
                maxWidth: '84px',
                whiteSpace: 'nowrap',
              }}
            >
              {step.label}
            </Typography>

            {index === activeStep && (
              <ArrowDropDownIcon
                sx={{
                  color: '#3B82F6',
                  marginTop: '2px',
                  fontSize: '18px',
                  animation: 'bounce 2s infinite',
                  '@keyframes bounce': {
                    '0%, 20%, 50%, 80%, 100%': {
                      transform: 'translateY(0)',
                    },
                    '40%': {
                      transform: 'translateY(-4px)',
                    },
                    '60%': {
                      transform: 'translateY(-2px)',
                    },
                  },
                }}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default StopperDeveloper;
